// import React, { Children, memo } from "react";
// import { COLORS } from "core";
// import { Col, Row, Statistic, Typography } from "antd";
// import CountUp from "react-countup";
// import { createUseStyles } from "react-jss";
// import { Button } from "components/src";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";

// const formatter = (value: any) => <CountUp end={value} separator="," />;
// const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  
//   main:{
//     // border:`1px solid ${colors.theme02}`,
//     borderRadius:"5%",
//     width:"280px",
//     height:'150px',
//     textAlign:'center',
//     boxShadow: `1px 1px 10px 1px${colors.theme02}`,
//     flexDirection:'row',
//     display:'flex',
//     justifyContent:'space-around',
//     backgroundColor:colors.theme02
//   },
//   box: {
//     margin:'24px',
//     display:'flex',
//     justifyContent:'center',
//     width: "100px",
//     height: "100px",
//     outline: `3px dotted ${colors.black}`,
//     borderRadius: "50%",
//     backgroundColor: colors.black,
//     textAlign: "center",
//     alignItems:'center',
//     transition: "ease 0.3s",
//     "&:hover": {
//       transform: "scale(1.1)",
//     },
//   },
//   icon: {
//     fontSize: "40px",
//     color: colors.theme02,
//   },
//   Statistic: {
//     fontWeight: "bolder",
//     color: colors.gray03,
//   },
//   bottomText:{
//     fontSize:'18px',
//     fontWeight:'bold',
//     marginTop:'55px'
//   }
// }));
// interface Props {
//   header?: string;
//   content?: string;
//   icon?: any;
//   value?: any;
//   children?:any;
//   create?: any;
//   view?: any;
//   text?: any;
// }

// const StatisticBox = memo<Props>(
//   ({ value, text }) => {
//     const navigate = useNavigate();
//     const classes = useStyle();
//     const { i18n } = useTranslation();

//     return (
//       <div className={classes.main}>
//         <div className={classes.box}>
//               <Statistic
//                 className={classes.Statistic}
//                 formatter={formatter}
//                 value={value}
//               />
//         </div>
//             <Typography className={classes.bottomText}>{text}</Typography>
//         </div>
//     );
//   }
// );

// export { StatisticBox };
import React, { memo } from "react";
import { COLORS } from "core";
import { Statistic, Typography } from "antd";
import CountUp from "react-countup";
import { createUseStyles } from "react-jss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const formatter = (value: any) => <CountUp end={value} separator="," />;
const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  main: {
    borderRadius: "5%",
    width: "90%",
    maxWidth: "280px",
    textAlign: "center",
    boxShadow: `1px 1px 10px 1px ${colors.theme02}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    backgroundColor: colors.theme02,
    margin: "10px auto",
    padding: "20px",
    "@media (min-width: 600px)": {
      flexDirection: "row",
      height: "auto",
    },
  },
  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "80px",
    height: "80px",
    outline: `3px dotted ${colors.black}`,
    borderRadius: "50%",
    backgroundColor: colors.black,
    textAlign: "center",
    transition: "transform 0.3s ease",
    marginBottom: "10px",
    "&:hover": {
      transform: "scale(1.1)",
    },
    "@media (min-width: 600px)": {
      width: "100px",
      height: "100px",
      marginBottom: "0",
      marginRight: "20px",
    },
  },
  icon: {
    fontSize: "40px",
    color: colors.theme02,
  },
  statistic: {
    fontWeight: "bolder",
    color: colors.gray03,
  },
  bottomText: {
    fontSize: "16px",
    fontWeight: "bold",
    "@media (min-width: 600px)": {
      fontSize: "18px",
    },
  },
}));

interface Props {
  header?: string;
  content?: string;
  icon?: any;
  value?: any;
  children?: any;
  create?: any;
  view?: any;
  text?: any;
}

const StatisticBox = memo<Props>(({ value, text }) => {
  const navigate = useNavigate();
  const classes = useStyle();
  const { i18n } = useTranslation();

  return (
    <div className={classes.main}>
      <div className={classes.box}>
        <Statistic
          className={classes.statistic}
          formatter={formatter}
          value={value}
        />
      </div>
      <Typography className={classes.bottomText}>{text}</Typography>
    </div>
  );
});

export { StatisticBox };

